
import { TYPE, canGo } from "network/network_api"
import { REQUEST_TYPE } from "network/net"
import Sun from "./sun"
import Star from "./star"
import Kosmos from "./kosmos"
import SETTINGS from "settings"
import { Image, kill_sound, getLocalizedPosition } from "utils"
import { literal_price } from "ui_commons"

const Texture = name => PIXI.utils.TextureCache[name];

const Sprite = name => new PIXI.Sprite(Texture(name));

const Tween = object => new TWEEN.Tween(object);

const Sound = name => sounds.get(`res/sounds/${name}`);
const CommonSound = name => sounds.get(`res/common/sounds/${name}`);

let $set_literal_price

function flowLabel( label, from, to, time, plain )
{
    const proxy = {value:from};
    
    //твин не дотекает всегда до окончательного значения за одинаковое время - устанавливаем принудительно (к тому же он .stop()-ится когда звук завершается):
    const flush = () => $set_literal_price.next( {
        label,
        value : to,
        plain
    } )
    
    const tween = Tween(proxy)
        .to({value:to}, time)
        .onUpdate(()=>{
            $set_literal_price.next( {
                label,
                value : ( proxy.value | 0 ),
                plain
            } )
        })
        .onComplete( flush )
        .onStop( flush )
        .start();

    return tween;
};

const emitter = (jackpotType, parentContainer) => {
    if (jackpotType == 6) {
        return new PIXI.particles.Emitter (
            parentContainer,
            [
                Texture('jp_coin_000.png'),
                Texture('jp_coin_001.png'),
                Texture('jp_coin_002.png'),
                Texture('jp_coin_003.png'),
                Texture('jp_coin_004.png'),
                Texture('jp_coin_005.png'),
                Texture('jp_coin_006.png'),
                Texture('jp_coin_007.png'),
                Texture('jp_coin_008.png'),
                Texture('jp_coin_009.png'),
                Texture('jp_coin_010.png')],
                {
                	'alpha': {
                		'start': 0.9,
                		'end': 1
                	},
                	'scale': {
                		'start': 0.5,
                		'end': 0.7,
                		'minimumScaleMultiplier': 0.5
                	},
                	'color': {
                		'start': '#ffffff',
                		'end': '#ffffff'
                	},
                	'speed': {
                		'start': 1000,
                		'end': 1000,
                		'minimumSpeedMultiplier': 0.9
                	},
                	'acceleration': {
                		'x': 0,
                		'y': 0
                	},
                	'maxSpeed': 0,
                	'startRotation': {
                		'min': 90,
                		'max': 90
                	},
                	'noRotation': false,
                	'rotationSpeed': {
                		'min': -600,
                		'max': 600
                	},
                	'lifetime': {
                		'min': 4,
                		'max': 4
                	},
                	'blendMode': 'normal',
                	'frequency': 0.01,
                	'emitterLifetime': -1,
                	'maxParticles': 1000,
                	'pos': {
                		'x': 0,
                		'y': 0
                	},
                	'addAtBack': false,
                	'spawnType': 'rect',
                	'spawnRect': {
                		'x': 0,
                		'y': -100,
                		'w': 1024,
                		'h': 100
                	}
                });
    }
    else if (jackpotType == 7) {
        return new PIXI.particles.Emitter (
            parentContainer,
            [
                Texture('jp_banknote_000.png'),
                Texture('jp_banknote_001.png'),
                Texture('jp_banknote_002.png'),
                Texture('jp_banknote_003.png'),
                Texture('jp_banknote_004.png'),
                Texture('jp_banknote_005.png')],
                {
                	'alpha': {
                		'start': 1,
                		'end': 1
                	},
                	'scale': {
                		'start': 0.7,
                		'end': 1.0,
                		'minimumScaleMultiplier': 0.7
                	},
                	'color': {
                		'start': '#ffffff',
                		'end': '#ffffff'
                	},
                	'speed': {
                		'start': 400,
                		'end': 500,
                		'minimumSpeedMultiplier': 0.5
                	},
                	'acceleration': {
                		'x': 0,
                		'y': 0
                	},
                	'maxSpeed': 0,
                	'startRotation': {
                		'min': 90,
                		'max': 90
                	},
                	'noRotation': false,
                	'rotationSpeed': {
                		'min': -100,
                		'max': 100
                	},
                	'lifetime': {
                		'min': 5,
                		'max': 5
                	},
                	'blendMode': 'normal',
                	'frequency': 0.05,
                	'emitterLifetime': -1,
                	'maxParticles': 1000,
                	'pos': {
                		'x': 0,
                		'y': 0
                	},
                	'addAtBack': false,
                	'spawnType': 'rect',
                	'spawnRect': {
                		'x': 0,
                		'y': -300,
                		'w': 1024,
                		'h': 150
                	}
                });
    }
    else if (jackpotType == 8) {
        return new PIXI.particles.Emitter (
            parentContainer,
            [
                Texture('jp_diamond_000.png'),
                Texture('jp_diamond_001.png'),
                Texture('jp_diamond_002.png'),
                Texture('jp_diamond_003.png'),
                Texture('jp_diamond_004.png')
            ],
            {
            	'alpha': {
            		'start': 1,
            		'end': 1
            	},
            	'scale': {
            		'start': 0.5,
            		'end': 0.7,
            		'minimumScaleMultiplier': 0.5
            	},
            	'color': {
            		'start': '#ffffff',
            		'end': '#ffffff'
            	},
            	'speed': {
            		'start': 600,
            		'end': 800,
            		'minimumSpeedMultiplier': 0.5
            	},
            	'acceleration': {
            		'x': 0,
            		'y': 0
            	},
            	'maxSpeed': 0,
            	'startRotation': {
            		'min': 90,
            		'max': 90
            	},
            	'noRotation': false,
            	'rotationSpeed': {
            		'min': -300,
            		'max': 300
            	},
            	'lifetime': {
            		'min': 4,
            		'max': 4
            	},
            	'blendMode': 'normal',
            	'frequency': 0.01,
            	'emitterLifetime': -1,
            	'maxParticles': 1000,
            	'pos': {
            		'x': 0,
            		'y': 0
            	},
            	'addAtBack': false,
            	'spawnType': 'rect',
            	'spawnRect': {
            		'x': 0,
            		'y': -100,
            		'w': 1024,
            		'h': 100
            	}
            });
    }
    else if (jackpotType == 9) {
        return new PIXI.particles.Emitter (
            parentContainer,
            [
                Texture('res/common/progressive_jackpot/particles/sparks_small/0.png'),
                Texture('res/common/progressive_jackpot/particles/sparks_small/1.png'),
                Texture('res/common/progressive_jackpot/particles/sparks_small/2.png'),
                Texture('res/common/progressive_jackpot/particles/sparks_small/3.png'),
                Texture('res/common/progressive_jackpot/particles/sparks_small/4.png'),
                Texture('res/common/progressive_jackpot/particles/sparks_small/5.png'),
                Texture('res/common/progressive_jackpot/particles/sparks_big/0.png'),
                Texture('res/common/progressive_jackpot/particles/sparks_big/1.png'),
                Texture('res/common/progressive_jackpot/particles/sparks_big/2.png'),
                Texture('res/common/progressive_jackpot/particles/sparks_big/3.png'),
                Texture('res/common/progressive_jackpot/particles/sparks_big/4.png'),
                Texture('res/common/progressive_jackpot/particles/sparks_big/5.png')
            ],
            {
            	'alpha': {
            		'start': 1,
            		'end': 0
            	},
            	'scale': {
            		'start': 0.5,
            		'end': 1,
            		'minimumScaleMultiplier': 0.5
            	},
            	'color': {
            		'start': '#ffffff',
            		'end': '#ffffff'
            	},
            	'speed': {
            		'start': 600,
            		'end': 800,
            		'minimumSpeedMultiplier': 0.5
            	},
            	'acceleration': {
            		'x': 0,
            		'y': 0
            	},
            	'maxSpeed': 0,
            	'startRotation': {
            		'min': 90,
            		'max': 90
            	},
            	'noRotation': false,
            	'rotationSpeed': {
            		'min': -300,
            		'max': 300
            	},
            	'lifetime': {
            		'min': 0.5,
            		'max': 1
            	},
            	'blendMode': 'normal',
            	'frequency': 0.005,
            	'emitterLifetime': -1,
            	'maxParticles': 1000,
            	'pos': {
            		'x': 0,
            		'y': 0
            	},
            	'addAtBack': false,
            	'spawnType': 'rect',
            	'spawnRect': {
            		'x': 0,
            		'y': -100,
            		'w': 1024,
            		'h': 100
            	}
            });
    }
};

const commetEmitterSettings = {
	'alpha': {
		'start': 0.5,
		'end': 0.1
	},
	'scale': {
		'start': 0.5,
		'end': 0.4,
		'minimumScaleMultiplier': 1
	},
	'color': {
		'start': '#ffffff',
		'end': '#ffffff'
	},
	'speed': {
		'start': 0,
		'end': 0,
		'minimumSpeedMultiplier': 1
	},
	'acceleration': {
		'x': 0,
		'y': 0
	},
	'maxSpeed': 0,
	'startRotation': {
		'min': -360,
		'max': 360
	},
	'noRotation': false,
	'rotationSpeed': {
		'min': -1000,
		'max': 1000
	},
	'lifetime': {
		'min': 0.1,
		'max': 0.7
	},
	'blendMode': 'normal',
	'frequency': 0.001,
	'emitterLifetime': -1,
	'maxParticles': 200,
	'pos': {
		'x': 0,
		'y': 0
	},
	'addAtBack': false,
	'spawnType': 'circle',
	'spawnCircle': {
		'x': 0,
		'y': 0,
		'r': 3
	}
};



let panels;
let blickMask;
let blick;
let splash;
let label;
let pressStart;

let tweenBlinkPressStart;

const blinkTweenHandlers = {};
const jpLabelScaleTween = {};
const jpLabelAlphaTween = {};

let sndIntro, sndGainUp, sndGainFinish;
const sndAmbient = {};
const sndFall = {};


let comets
let emitters

// текстуры голов комет
const commetHeadingTextures = [
    'res/common/progressive_jackpot/headlight00.png',//blue
    'res/common/progressive_jackpot/headlight01.png',//green
    'res/common/progressive_jackpot/headlight02.png',//magenta
    'res/common/progressive_jackpot/headlight03.png',//red
]

// частицы в хвосте комет
const tailParticleTextures = [
    'res/common/progressive_jackpot/particles/sparks_small/4.png',// blue
    'res/common/progressive_jackpot/particles/sparks_small/1.png',//green
    'res/common/progressive_jackpot/particles/sparks_small/3.png',//magenta
    'res/common/progressive_jackpot/particles/sparks_small/5.png',//2 - red 5 - yellow
]

// твины падения комет (чтобы прервать)
let cometTweenHandlers = {};
function stop_comets()
{
    // останавливаем кометы
    cometTimeHandlers.forEach(handler => {
        if (handler) clearTimeout(handler);
    });
    cometTimeHandlers.length = 0

    const keys = Object.keys(cometTweenHandlers);
    for (const key in keys) {
        if (cometTweenHandlers[key]) cometTweenHandlers[key].stop();
        delete cometTweenHandlers[key];
    }

    for (const i in emitters) {
        const emitter = emitters[i];
        emitter.cleanup();
        emitter.emit = false;
        emitter.visible = false;
    }

    for (const i in comets) {
        const commet = comets[i];
        commet.visible = false;
    }
}

function terminate()
{
    for ( let i in sndAmbient )
    {
        kill_sound( sndAmbient[ i ] )
        delete sndAmbient[ i ]
    }
    
    for ( let i in sndFall )
    {
        kill_sound( sndFall[ i ] )
        delete sndFall[ i ]
    }
    
    kill_sound( sndIntro )
    sndIntro = undefined
    
    kill_sound( sndGainUp )
    sndGainUp = undefined
    
    kill_sound( sndGainFinish )
    sndGainFinish = undefined
    
    if ( tweenBlinkPressStart ) tweenBlinkPressStart.kill()
    
    for ( let i in blinkTweenHandlers )
    {
        blinkTweenHandlers[ i ].kill()
        delete blinkTweenHandlers[ i ]
    }
    
    for ( let i in jpLabelScaleTween )
    {
        jpLabelScaleTween[ i ].kill()
        delete jpLabelScaleTween[ i ]
    }
    
    stop_comets()
}

// запуск перемещения кометы и запуск системы частиц для хвоста кометы
const emitCommet = (index, done) => {

    const commetHead = comets[index];
    const commetTail = emitters[index];

    const position = {x:10 + Math.random() * 1024, y: -30};

    commetHead.visible = true;
    commetHead.position.set(position.x, position.y);

    commetTail.cleanup();
    commetTail.resetPositionTracking();
    commetTail.updateSpawnPos(position.x, position.y);
    commetTail.visible = true;
    commetTail.emit = true;

    const tween = new TWEEN.Tween(commetHead.position)
        .to({y:900}, 2000)
        .onUpdate(()=>{
            commetTail.updateSpawnPos(position.x, commetHead.position.y);
        })
        .onComplete(()=>{
            commetHead.visible = false;
            commetTail.emit = false;
            commetTail.visible = false;
            commetTail.cleanup();
            cometTweenHandlers[index] = null;
            done();
        })
        .start();
    cometTweenHandlers[index] = tween;
};

const randomPause = () => 1000 + 10 * Math.floor(Math.random() * 500);

// массив индексов незапущенных комет
let cometsPull = [];
// массив индексов запущенных комет
let activeComets = [];

// хендлеры setTimeout комет, ожидающих вылета (чтобы можно было прервать)
let cometTimeHandlers = [];

// вызов запуска кометы если пулл ожидающих комет это позволяет, иначе пауза и повторная попытка заупска
const launch = (taskId) => {
    // console.log(`comets:${cometsPull.length}, active:${activeComets.length}`);
    if (cometsPull.length) {
        const i = cometsPull.shift();
        activeComets.push(i);
        emitCommet(i, () => {
            const index = activeComets.findIndex(item => item == i);
            activeComets.splice(index, 1);
            cometsPull.push(i);

            cometTimeHandlers[taskId] = setTimeout(launch.bind(null, taskId), randomPause());
        });
    }
    else {
        cometTimeHandlers[taskId] = setTimeout(launch.bind(null, taskId), randomPause());
    }
};

// главная ф-ция запуска падения комет
const launchComets  = () => {
    cometTweenHandlers = [];
    cometTimeHandlers = [];
    cometsPull = [];
    activeComets = [];
    for (let i = 0; i < comets.length; i++) {
        cometsPull.push(i);
    }

    for (let i = 0; i < comets.length; i++) {
        const handler = setTimeout(launch.bind(null, i), randomPause());
        cometTimeHandlers.push(handler);
    }
};

// перетекание выигрыша джекпота в поле кредитов
// за время, зависящее логарифмически от величины выигрыша
function flowToCredits(
    credits_win,
    money_win,
    credits,
    money,
    $flow_complete,
    credits_label,
    money_label
)
{
	if (tweenBlinkPressStart) {
		tweenBlinkPressStart.stop();
	}
    pressStart.visible = false;
	pressStart.alpha = 1.0;

    let time = Math.log10( credits_win ) * 1000;
    time = time < 3600 ? 3600 : time;
    
    label.my_name = "win"
    const winTween = flowLabel( label, money_win, 0, time )
    
    credits_label.my_name = "credits"
    const creditsTween = flowLabel(
        credits_label,
        credits,
        credits + credits_win,
        time,
        true
    )
    
    money_label.my_name = "money"
    const money_tween = flowLabel(
        money_label,
        money,
        money + money_win,
        time
    )

    sndGainUp.once('end', ()=>{
        label.text = ""
        credits_label.text = credits + credits_win;

        sndGainFinish.play();
        
        winTween.stop();
        creditsTween.stop();
        money_tween.stop()

        $flow_complete.next();
    });


    sndGainUp.play();
}

function make_money_label( container, $balance )
{
    const currencyFrame = Image( 'res/common/progressive_jackpot/jp_money_panel.png' )
    container.addChild( currencyFrame );
    
   currencyFrame.position.set(0, 683);

    const currencySignLabel = new PIXI.BitmapText('0', {font: 'jp_currency_font'});
    currencySignLabel.anchor.x = 0.5;
    currencySignLabel.position.set( 38, 0 );
    currencyFrame.addChild( currencySignLabel );

    const currencyValueLabel = new PIXI.BitmapText('0', {font: 'jp_money_font'});
    currencyValueLabel.anchor.x = 1.0;
    currencyValueLabel.position.set( 212, 8);
    currencyFrame.addChild( currencyValueLabel );

    //из-за того что прогрессивный джекпот применяет отложенную загрузку, он не участвует в инициализации стримов начальными значениями, поэтому приходится так оборачивать чтобы вызывать самостоятельно:
    function on_balance( balance )
    {
        if ( ! balance ) return
        currencySignLabel.text = balance.currency.code_name;
        
        currencyValueLabel.text = literal_price( balance.gameable_money, balance.currency.minor_unit, balance.currency.delimiter )
        
        //если currency->visible->false И currency->minor_units = 0 тогда панель с валютой в джекпоте не показывается:
        currencyFrame.visible = ! ( balance.currency.visible == false && balance.currency.minor_unit == 0 )
    }
    $balance.on( on_balance )
    on_balance( $balance.value )
    
    return currencyValueLabel
}

// 1) первый джекпот озвучивается где то секунд 10-12, в это время слить его нельзя и надпись "press start" появляется только после этого времени. По окончанию этого времени ВСЯ анимация останавливается.
// 2) второй джекпот озвучивается в три раза больше (По окончанию этого времени ВСЯ анимация останавливается.), слить его нельзя как и первый 10-12секунд и надпись "press start" появляется только после этого времени
// 3) третий джекпот озвучивается и анимируется постоянно , слить его нельзя как и первый 10-12секунд и надпись "press start" появляется только после этого времени

/** Прогрессивный джекпот. Не путать с "просто" джекпотом - оба существуют в игре и не мешают друг другу.*/
export default function( space, container )
{
	const config = SETTINGS.progressive_jackpot_config

    space.s( "error" ).on( terminate )
    
    emitters = []
    
    $set_literal_price = space.s( "progressive_jackpot:set_literal_price" )
    $set_literal_price
        .with( space.s( "balance" ), ( { value, label, plain }, balance ) => ({ value, label, plain, balance }) )
        .on( ({ label, value, plain, balance }) => {
            const literal = plain ? value : literal_price( value, balance.currency.minor_unit, balance.currency.delimiter )
            label.text = value != 0 ? literal : ""
        } )
    
    space.s( "balance:credits" ).on( credits => {if (credits) {txtCredits.text = credits}} )
    space.s( "balance:credits" ).propagate( space.s( "balance:credits" ).value )

    space.s( "state" )
        .map( state => state.type == TYPE.PROGRESSIVE_JACKPOT )
        .to( space.s( "is_progressive_jackpot" ) )

    const $flow = space.s( "progressive_jackpot:flow", false )
    const $flow_complete = space.s( "progressive_jackpot:flow_complete" )

    const $delay = space.s( "progressive_jackpot:delay", 0 )
    space.s( "ticker" )
        .with( $delay, ( s, d ) => d + s )
        .to( $delay )

    $delay
        .map( d => d > 12 )
        .to( space.s( "progressive_jackpot:1st_animation_complete" ) )
    $delay
        .map( d => d > 36 )
        //.with( $flow, ( c, f ) => c || f )
        .to( space.s( "progressive_jackpot:2nd_animation_complete" ) )

    $flow.filter(f => f).on(() => $delay.next(37));

    //чтобы не прокликивался под джекпотом барабан:
    container.interactive = true;
    const $animating = space.s( "progressive_jackpot:animating" )
    space.s( "progressive_jackpot:animating" )
        .filter( a => a )
        .delay( 12000 )
        .do( () => {
        	if (tweenBlinkPressStart) {
        		tweenBlinkPressStart.stop();
			}
            pressStart.visible = true;
            pressStart.alpha = 1.0;
            tweenBlinkPressStart = Tween(pressStart)
                .to({alpha: 0}, 750)
                .repeat(Infinity)
                .delay(100)
                .yoyo(true)
                .easing(TWEEN.Easing.Cubic.InOut)
                .start();
        })
        .map( () => false )
        .to( space.s( "progressive_jackpot:animating" ) )
    const $click = space.s( "progressive_jackpot:click" )
    container.on( "pointerdown", () => $click.next() )
    const ENTER = 13
    const SPACE = 32
    const F8    = 119
    space.s( "keyboard" )
        .filter( k => _.includes( [ ENTER, SPACE, F8 ], k ) )
        .with( space.s( "is_progressive_jackpot" ), ( _, pj ) => pj )
        .filter( pj => pj )
        .to( $click )
    $click
        .with(
            space.s( "progressive_jackpot:animating" ),
            $flow,
            space.s( "pending" ),
            ( _, animating, flow, p ) => ({ animating, flow, p })
        )
        .filter( ({ animating, flow, p }) => ! animating && ! flow && ! p )
        .with(
            space.s( "state" ),
            space.s( "balance:credits" ),
            space.s( "balance:money" ),
            ( _, state, credits, money ) => ({ state, credits, money })
        )
        .on( ({ state, credits, money }) => {
            $flow.next( true )
            if ( state.type == TYPE.PROGRESSIVE_JACKPOT && state.state.stage.math.jackpot_progressive.type_id == 8 )
            {
                space.s( "progressive_jackpot:3rd_animation_complete" ).next( true )
            }
            if ( state.type == TYPE.PROGRESSIVE_JACKPOT && state.state.stage.math.jackpot_progressive.type_id == 9 )
            {
                //space.s( "progressive_jackpot:4th_animation_complete" ).next( true );
                if ( sndAmbient[9].playing() ) {
                    sndAmbient[9].fade( 1, 0, 500 );
                }
                if (sndFall[9].playing()) {
                    sndFall[9].fade( 1, 0, 500 );
				}
            }
            flowToCredits(
                state.state.open_win,
                state.state.open_win_money,
                credits,
                money,
                $flow_complete,
                txtCredits,
                money_label
            )
        } )
    $flow_complete.on( () => {
        $flow.next( false )
        space.s( "ui:collect" ).next()//space.s( "ui:barrelClick" ).next()
    } )

    screen( space, container, 6, Sun, {
        center_1 : [ 203 / 255, 97 / 255, 9 / 255 ],
        end_1 : [ 132 / 255, 63 / 255, 6 / 255 ],
        center_2 : [ 255 / 255, 128 / 255, 13 / 255 ],
        end_2 : [ 211 / 255, 115 / 255, 28 / 255 ],
		id: 0,
        $complete : space.s( "progressive_jackpot:1st_animation_complete" )
    } )

    screen( space, container, 7, Sun, {
        center_1 : [ 84 / 255, 136 / 255, 0 / 255 ],
        end_1 : [ 0 / 255, 34 / 255, 1 / 255 ],
        center_2 : [ 109 / 255, 144 / 255, 24 / 255 ],
        end_2 : [ 38 / 255, 56 / 255, 40 / 255 ],
		id: 1,
        $complete : space.s( "progressive_jackpot:2nd_animation_complete" )
    } )

    screen( space, container, 8, Star, {
        $complete : space.s( "progressive_jackpot:3rd_animation_complete" )
    } );

    screen( space, container, 9, Kosmos, {
        $complete : space.s( "progressive_jackpot:4th_animation_complete" )
    } )
    makeComets( container )

    //видим только пока состояние джекпота:
    space.s( "is_progressive_jackpot" ).on( pj => container.visible = pj )

    //переход на состояние джекпота как только останавливается барабан:
    space.s( "barrel:stop" )
        .with( space.s( "state" ), space.s( "pending" ), ( _, state, pending ) => ({ state, pending }) )
        .filter( ({ state, pending }) => canGo( TYPE.PROGRESSIVE_JACKPOT, state ) && pending === undefined )
        .map( () => ({ type : REQUEST_TYPE.PROCEED }) )
        .to( space.s( "request" ) );


    panels = [];
    for (let i = 0; i < 4; ++i) {
    	let panel = Sprite(config.panels.textures[i]);
        if (config.panels.anchor) panel.anchor.set(config.panels.anchor.x, config.panels.anchor.y);
        panel.position.set(config.panels.position.x, config.panels.position.y);
        container.addChild(panel);
        panels.push(panel);
	}

    blick = Sprite(config.blick.texture);
    let pos = getLocalizedPosition(config.blick);
    blick.position.set(pos.x, pos.y);

    splash = Sprite(config.splash.texture);
    if (config.splash.anchor) splash.anchor.set(config.splash.anchor.x, config.splash.anchor.y);
    let splash_pos = getLocalizedPosition(config.splash);
    splash.position.set(splash_pos.x, splash_pos.y);
    splash.visible = false;

    // const gui = new dat.GUI();
    // const folder = gui.addFolder('coins');
    // folder.add(splash.position, 'x', -500, 500);
    // folder.add(splash.position, 'y', -500, 500);

    blickMask = Sprite('res/common/progressive_jackpot/jp_blick_mask.png');
    blickMask.position.set(-366,0);
    blick.addChild(blickMask);
    blick.mask = blickMask;

    label = new PIXI.BitmapText( '', {font: 'jp_big_digits_font'});
    label.position.set(config.jackpot_label.position.x, config.jackpot_label.position.y);
    if (config.jackpot_label.anchor) label.anchor.set(config.jackpot_label.anchor.x, config.jackpot_label.anchor.y);

    pressStart = Sprite(config.pressStart.texture);
    if (config.pressStart.anchor) pressStart.anchor.set(config.pressStart.anchor.x, config.pressStart.anchor.y);
    pressStart.position.set(config.pressStart.position.x, config.pressStart.position.y);
    pressStart.visible = false;
    container.addChild(pressStart);
    
    
    const money_label = make_money_label( container, space.s( "balance" ) )

    const creditsFrame = Sprite(config.creditsFrame.texture);
    creditsFrame.position.set(config.creditsFrame.position.x, config.creditsFrame.position.y);
    container.addChild(creditsFrame);

    const txtCredits = new PIXI.BitmapText( '', {font: 'jp_credits_font'});
    txtCredits.position.set(config.creditsFrame.text_position.x, config.creditsFrame.text_position.y);
    if (config.creditsFrame.text_anchor) txtCredits.anchor.set(config.creditsFrame.text_anchor.x, config.creditsFrame.text_anchor.y);
    creditsFrame.addChild(txtCredits);


    sndIntro = CommonSound('progressive_jackpot/intro');
    sndGainUp = CommonSound('progressive_jackpot/gain_up');
    sndGainFinish = CommonSound('progressive_jackpot/gain_stop');

    sndIntro.volume(0.7);
    sndGainUp.volume(0.7);
    sndGainFinish.volume(0.7);

    const sndCoinsMusic = CommonSound('progressive_jackpot/coins/music');
    sndCoinsMusic.loop(true);
    sndCoinsMusic
    sndAmbient[6] = sndCoinsMusic;

    const sndCoinsFall = CommonSound('progressive_jackpot/coins/sound');
    sndCoinsFall.loop(true);
    sndCoinsFall.volume(0.7);
    sndFall[6] = sndCoinsFall;

    const sndBanknotesMusic = CommonSound('progressive_jackpot/dollars/music');
    sndBanknotesMusic.loop(true);
    sndBanknotesMusic.volume(0.7);
    sndAmbient[7] = sndBanknotesMusic;

    const sndBanknotesFall = CommonSound('progressive_jackpot/dollars/sound');
    sndBanknotesFall.loop(true);
    sndBanknotesFall.volume(0.7);
    sndFall[7] = sndBanknotesFall;

    const sndDiamondsMusic = CommonSound('progressive_jackpot/diamonds/music');
    sndDiamondsMusic.loop(true);
    sndDiamondsMusic.volume(0.7);
    sndAmbient[8] = sndDiamondsMusic;

    const sndDiamondsFall = CommonSound('progressive_jackpot/diamonds/sound');
    sndDiamondsFall.loop(true);
    sndDiamondsFall.volume(0.7);
    sndFall[8] = sndDiamondsFall;


    const sndGalaxyMusic = CommonSound('progressive_jackpot/galaxy/music');
    sndGalaxyMusic.loop(true);
    sndGalaxyMusic.volume(0.7);
    sndAmbient[9] = sndGalaxyMusic;

    const sndGalaxyFall = CommonSound('progressive_jackpot/galaxy/sound');
    // sndGalaxyFall.loop(true);
    sndGalaxyFall.volume(0.7);
    sndFall[9] = sndGalaxyFall;

    const scaleValue = (SETTINGS.screen.resolution.width / 1024) || 1;
    container.scale.set(scaleValue);
}

function makeComets( container )
{
    comets = []
    
    const tails = new PIXI.Container;
    container.addChild( tails );
    const heads = new PIXI.Container;
    container.addChild( heads );

    for (let j = 0; j < 2; j++) {
        for (let i = 0; i < 4; i++) {
            const emitter = new PIXI.particles.Emitter (
                tails,
                [ PIXI.utils.TextureCache[ tailParticleTextures[i] ] ],
                commetEmitterSettings
            );
            emitter.autoUpdate = true;
            emitter.emit = false;
            emitters.push(emitter);

            const commet = Image( commetHeadingTextures[i] );
            commet.anchor.set(0.5);
            commet.alpha = 0.9;
            commet.visible = false;
            heads.addChild(commet);

            comets.push(commet);
        }
    }
}


function showWin(win, type_id, particleEmitter) {
    const unzoomCompleted = () => {

        splash.visible = false;
        splash.scale.set(1);
        jpLabelScaleTween[type_id] = Tween(splash.scale)
            .to({x:7, y:7}, 1000)
            .repeat(Infinity)
            .delay(1000)
            .repeatDelay(5000)
            .start();

        splash.alpha = 1;
        jpLabelAlphaTween[type_id] = Tween(splash)
            .to({alpha:0}, 1000)
            .onStart(()=>{
              splash.visible = true;
            })
            .repeat(Infinity)
            .delay(1000)
            .repeatDelay(5000)
            .start();

        blickMask.position.set(-366,0);
        blinkTweenHandlers[type_id] = Tween(blickMask.position)
            .to({x:630 + 366}, 1000)
            .repeat(Infinity)
            .repeatDelay(2000)
            .start();


        if (type_id == 9) {
            launchComets();
        }

        particleEmitter.emit = true;
        sndAmbient[type_id].stop();
        sndAmbient[type_id].volume( 1 );
        sndAmbient[type_id].play();
        sndFall[type_id].stop();
        sndFall[type_id].volume( 1 );
        sndFall[type_id].play();
    };

    sndIntro.play();
    pressStart.visible = false;

    panels.forEach(p => p.visible = false);
    let actualPanel = panels[type_id - 6];

    actualPanel.visible = true;
    actualPanel.addChild(blick);
    actualPanel.addChild(splash);
    splash.visible = false;
    actualPanel.addChild(label);

    actualPanel.scale.set(10,10);
    $set_literal_price.next( { label, value : win } )
    Tween(actualPanel.scale)
        .to({x:1,y:1}, 500)
        .onComplete(unzoomCompleted)
        .start();
}

function stopShow(type_id, particleEmitter, fade = false ) {

    if ( ! particleEmitter.emit ) return;
    particleEmitter.emit = false;
    if (blinkTweenHandlers[type_id]) {
        blinkTweenHandlers[type_id].stop();
        blickMask.position.set(-366,0);
        delete blinkTweenHandlers[ type_id ]
    }

    if (jpLabelScaleTween[type_id]) {
        jpLabelScaleTween[type_id].stop();
        delete jpLabelScaleTween[ type_id ]
    }

    if (jpLabelAlphaTween[type_id]) {
        jpLabelAlphaTween[type_id].stop();
        delete jpLabelAlphaTween[ type_id ]
    }

    splash.visible = false;

    if (type_id == 9) {
        stop_comets()
    }

    if ( fade )
    {
        sndAmbient[type_id].fade( 1, 0, 500 );
        sndFall[type_id].fade( 1, 0, 500 );
    }
    else
    {
        sndAmbient[type_id].stop();
        sndFall[type_id].stop();
    }
}

function screen( space, container, type_id, f, settings ) {
    const view = new PIXI.Container;
    container.addChild( view );

    const emitterContainer = new PIXI.Container();
    container.addChild(emitterContainer);

    const particleEmitter = emitter(type_id, emitterContainer);
    particleEmitter.autoUpdate = true;

    settings.$complete.on( c => c && stopShow( type_id, particleEmitter, true ) )

    space.s( "state" )
        .map( state => ({
            visible:state.type == TYPE.PROGRESSIVE_JACKPOT && state.state.stage.math.jackpot_progressive.type_id == type_id,
            state}) )
        .on( info => {
            view.visible = info.visible;

            if (info.visible) {
                showWin(info.state.state.open_win_money, type_id, particleEmitter);

                space.s( "progressive_jackpot:delay" ).next( 0 );
                space.s( "progressive_jackpot:animating" ).next( true );
                space.s( "progressive_jackpot:3rd_animation_complete" ).next( false )
            }
            else {
                stopShow(type_id, particleEmitter);
            }
        } );

    f( space, view, settings );
}



// WEBPACK FOOTER //
// ./src/library/progressive_jackpot/progressive_jackpot.es6